export default __webpack_public_path__ + "static/logo-3e1aa0f1134f7c5c764b3d14d34a2cdf.png";